<div class="tw-flex tw-flex-col tw-gap-3">
  <div
    class="tw-flex tw-items-center tw-justify-between tw-gap-4 md:tw-flex-col md:tw-items-stretch"
  >
    <label for="keychain-config" class="tw-block tw-text-[13px] tw-text-color-text-default">
      {{ "keychain" | i18n }}
    </label>
    <app-gloss-button
      class="tw-shrink-0 md:tw-block md:tw-w-full"
      [options]="{
        text: (isOpen ? 'close' : 'open') | i18n,
        fullClass:
          'tw-h-9 tw-w-auto tw-px-5 tw-rounded-xl tw-border tw-border-solid tw-border-color-border-subtle tw-bg-color-surface-input tw-text-color-text-default md:tw-h-11 md:tw-w-full',
        ghostDisabled: true,
        ghostShadow: true,
        isEnabled: !isSaving && !isTogglingOpen,
        onClick: toggleOpen.bind(this),
      }"
    ></app-gloss-button>
  </div>

  @if (isOpen) {
    <textarea
      id="keychain-config"
      class="tw-w-full tw-rounded-xl tw-border-none tw-bg-color-surface-input tw-p-3 tw-font-mono tw-text-[12px] tw-text-color-text-default tw-outline-none focus:tw-shadow-elevation-input-focus"
      style="height: 200px"
      [formControl]="formControl"
      [readOnly]="isSaving"
    ></textarea>
    <app-gloss-button
      class="md:tw-block md:tw-w-full"
      [options]="{
        text: 'save' | i18n,
        type: 'submit',
        fullClass:
          'tw-h-9 tw-w-auto tw-rounded-xl tw-px-5 tw-border-none tw-bg-color-action-primary tw-shadow-elevation-card tw-text-color-text-on-action md:tw-h-11 md:tw-w-full',
        ghostDisabled: true,
        ghostShadow: true,
        isEnabled: formControl.dirty && formControl.valid && !isSaving,
        onClick: save.bind(this),
      }"
    ></app-gloss-button>
  }
</div>
